import { jsxs as g, jsx as i, Fragment as j } from "react/jsx-runtime";
import N from "clsx";
import { forwardRef as w, useRef as I, useEffect as z } from "react";
const A = (e) => N(e), G = (e) => (a) => {
  e.forEach((l) => {
    typeof l == "function" ? l(a) : l != null && (l.current = a);
  });
}, H = (e) => N(e), J = () => `${Math.random().toString(36)}00000000000000000`.slice(2, 7), K = (e) => (a) => {
  e.forEach((l) => {
    typeof l == "function" ? l(a) : l != null && (l.current = a);
  });
}, o = "dds-checkbox-v0173", O = w(
  ({
    ariaDescribedby: e,
    defaultChecked: a = !1,
    className: l = "",
    disabled: s = !1,
    hiddenLabel: r = !1,
    id: t,
    indeterminate: u = !1,
    inputProps: $ = {},
    invalid: h = !1,
    label: f = "Default label",
    labelNode: m,
    name: y,
    onChange: _,
    value: L,
    ...v
  }, b) => {
    const C = {
      [o]: !0,
      [l]: l.length > 0,
      [`${o}--disabled`]: s,
      [`${o}--invalid`]: h
    }, d = I(null), { current: n } = I(`${o}-${J()}`), p = t || n;
    return z(() => {
      a && d.current ? (d.current.checked = !0, d.current.indeterminate = !1) : u && d.current ? (d.current.checked = !1, d.current.indeterminate = !0) : d.current && (d.current.checked = !1, d.current.indeterminate = !1);
    }, [u, a]), /* @__PURE__ */ g("label", { htmlFor: p, className: H(C), ...v, children: [
      /* @__PURE__ */ i(
        "input",
        {
          "aria-describedby": e,
          "aria-invalid": h ? "true" : "false",
          id: p,
          type: "checkbox",
          className: `${o}__input`,
          defaultChecked: a,
          disabled: s,
          name: y,
          value: L,
          "aria-label": r ? f : void 0,
          ref: K([d, b]),
          ...$,
          onChange: s ? void 0 : _
        }
      ),
      /* @__PURE__ */ g("div", { className: `${o}__control`, children: [
        /* @__PURE__ */ i(
          "svg",
          {
            className: `${o}__glyph ${o}__glyph--check`,
            viewBox: "0 0 8 8",
            children: /* @__PURE__ */ i("path", { d: "M6.779,0.297c0.204-0.306,0.618-0.389,0.924-0.185c0.276,0.184,0.37,0.537,0.238,0.83L7.888,1.037L3.444,7.703 c-0.212,0.318-0.641,0.388-0.94,0.174L2.417,7.805L0.195,5.583c-0.26-0.26-0.26-0.682,0-0.943c0.231-0.231,0.591-0.257,0.85-0.077 L1.138,4.64l1.646,1.646L6.779,0.297z" })
          }
        ),
        /* @__PURE__ */ i(
          "svg",
          {
            className: `${o}__glyph ${o}__glyph--indeterminate`,
            viewBox: "0 0 8 8",
            children: /* @__PURE__ */ i("path", { d: "M0,4c0-0.368,0.298-0.667,0.667-0.667h6.667C7.702,3.333,8,3.632,8,4S7.702,4.667,7.333,4.667H0.667 C0.298,4.667,0,4.368,0,4z" })
          }
        ),
        /* @__PURE__ */ i("div", { className: `${o}__hidden-touch-target` })
      ] }),
      !r && (m ?? /* @__PURE__ */ i("span", { className: `${o}__label`, children: f }))
    ] });
  }
), Q = (e) => N(e), U = () => `${Math.random().toString(36)}00000000000000000`.slice(2, 7), V = (e) => N(e), W = "dds-help-text-v0142";
function X({ children: e, className: a = "", disabled: l = !1, id: s, ...r }) {
  const t = {
    [W]: !0,
    [a]: a.length > 0
  };
  return /* @__PURE__ */ i(
    "p",
    {
      className: V(t),
      id: s,
      "aria-disabled": l ? "true" : void 0,
      ...r,
      children: e
    }
  );
}
const Y = (e) => N(e), F = "dds-label-v0162";
function Z({
  as: e,
  children: a,
  className: l = "",
  htmlFor: s,
  optional: r = !1,
  required: t = !1,
  ...u
}) {
  const $ = {
    [F]: !0,
    [l]: l.length > 0
  };
  return /* @__PURE__ */ g(e || "label", { htmlFor: s, className: Y($), ...u, children: [
    a,
    t ? /* @__PURE__ */ i("abbr", { className: `${F}__required-indicator`, title: "This field is required", children: "*" }) : "",
    !t && r ? /* @__PURE__ */ i("span", { className: `${F}__optional-indicator`, title: "This field is optional", children: "(optional)" }) : ""
  ] });
}
const P = (e) => N(e), k = "dds-validation-message-v0142";
function ee({
  children: e,
  className: a = "",
  id: l,
  invalid: s = !1,
  ...r
}) {
  const t = {
    [k]: !0,
    [a]: a.length > 0,
    [`${k}--${s ? "invalid" : "valid"}`]: !0
  };
  return /* @__PURE__ */ i("p", { id: l, className: P(t), ...r, children: e });
}
const c = "dds-form-field-v0142";
function ae({
  children: e,
  className: a = "",
  controlsLayoutDirection: l = "column",
  controlsLayoutGap: s = "default",
  disabled: r = !1,
  helpText: t,
  hiddenLabel: u = !1,
  id: $,
  invalid: h = !1,
  label: f,
  layoutDirection: m = "column",
  centerLabel: y = !1,
  optional: _ = !1,
  required: L = !1,
  role: v,
  validationMessage: b,
  ...C
}) {
  const { current: d } = I(`${c}-${U()}`), n = `${d}--label-id`, p = $ || `${d}--control-id`;
  let M, S;
  const D = [];
  t && (M = t ? `${d}--help-text-id` : void 0, D.push(M)), b && (S = b ? `${d}--validation-message-id` : void 0, D.push(S));
  const x = D.length > 0 ? D.join(" ") : void 0, T = {
    [c]: !0,
    [a]: a.length > 0,
    [`${c}--disabled`]: r,
    [`${c}--${m}`]: !0,
    [`${c}--${m}-centered`]: y,
    [`${c}--controls-layout-${l}`]: !0,
    [`${c}--controls-layout-gap-${s}`]: !0
  }, E = v === "group" || v === "radiogroup", B = E ? "span" : "label", R = E && !u;
  return /* @__PURE__ */ g(
    "div",
    {
      className: Q(T),
      role: v,
      "aria-invalid": v === "radiogroup" && h ? "true" : void 0,
      "aria-label": E && u ? f : void 0,
      "aria-labelledby": R ? n : void 0,
      ...C,
      children: [
        u ? "" : /* @__PURE__ */ g("div", { className: `${c}__label-section`, children: [
          /* @__PURE__ */ i(
            Z,
            {
              as: B,
              className: `${c}__label`,
              htmlFor: p,
              id: n,
              optional: _,
              required: L,
              children: f
            }
          ),
          t && M && /* @__PURE__ */ i(
            X,
            {
              id: M,
              disabled: r,
              className: `${c}__help-text`,
              children: t
            }
          )
        ] }),
        /* @__PURE__ */ g("div", { className: `${c}__control-section`, children: [
          /* @__PURE__ */ i("div", { className: `${c}__controls-wrapper`, children: e({
            ariaDescribedbyIds: x,
            ariaLabel: !E && u ? f : void 0,
            helpTextId: M,
            invalid: h,
            labelId: n,
            primaryControlId: p,
            validationMessageId: S
          }) }),
          b && S && /* @__PURE__ */ i(
            ee,
            {
              id: S,
              invalid: h,
              className: `${c}__validation-message`,
              children: b
            }
          )
        ] })
      ]
    }
  );
}
const q = "dds-checkbox-field-v0182", ne = w(
  ({
    className: e = "",
    disabled: a = !1,
    helpText: l,
    hiddenLabel: s = !1,
    invalid: r = !1,
    label: t,
    layoutDirection: u = "column",
    name: $,
    onChange: h,
    optional: f = !1,
    options: m,
    controlsLayoutDirection: y = "column",
    required: _ = !1,
    validationMessage: L,
    ...v
  }, b) => {
    const C = {
      [q]: !0,
      [e]: e.length > 0
    };
    return !m || m.length === 0 ? null : /* @__PURE__ */ i(
      ae,
      {
        className: A(C),
        label: t,
        helpText: l,
        validationMessage: L,
        invalid: r,
        hiddenLabel: s,
        optional: f,
        required: _,
        disabled: a,
        layoutDirection: u,
        controlsLayoutDirection: y,
        centerLabel: !1,
        role: "group",
        ...v,
        children: ({ ariaDescribedbyIds: d }) => /* @__PURE__ */ i(j, { children: m.map((n, p) => /* @__PURE__ */ i(
          O,
          {
            ariaDescribedby: d,
            className: `${q}__checkbox`,
            defaultChecked: n.defaultChecked,
            disabled: a === !0 ? !0 : n.disabled,
            hiddenLabel: n.hiddenLabel,
            id: n.id,
            indeterminate: n.indeterminate,
            inputProps: {
              "aria-required": _ ? "true" : void 0
            },
            invalid: r,
            label: n.label,
            labelNode: n.labelNode,
            name: n.name || $,
            onChange: h,
            value: n.value,
            ref: G([n.ref || null, b])
          },
          n.id ?? p
        )) })
      }
    );
  }
);
export {
  ne as CheckboxField
};
//# sourceMappingURL=index.js.map
